import { configQuery, isCoreXQuery } from '@gig/magic-common';
import { USER_JURISDICTION_UPDATED, GAME_SESSION_UPDATED, BREAKPOINT_DEVICE_UPDATED, DEVICE_QUERY_IS_DESKTOP, ENABLE_CONTINUE_PLAYING_QUERY, NET_POSITION_BAR_UPDATED, NET_POSITION_AMOUNT_UPDATED, ENABLE_CONTINUE_PLAYING_UPDATED, FEATURE_QUERY_VALUE, Feature } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { isUKGC, isAGCO } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';

var GameSessionService = /** @class */ (function () {
    function GameSessionService() {
        var _this = this;
        this.isDesktop = false;
        this.isCoreX = false;
        this.gameSession = null;
        this.netPosition = 0;
        this.previousSpinBalance = 0;
        this.firstNetPosition = true;
        this.gameTransactionSubscription = null;
        this.userWallets = null;
        this.registerSchemas();
        isCoreXQuery().then(function (isCoreX) {
            _this.isCoreX = isCoreX;
            _this.subscribeToNetPositionBarChanges();
            _this.subscribeToEnableContinuePlayingChanges();
        });
    }
    GameSessionService.prototype.subscribeToNetPositionBarChanges = function () {
        var _this = this;
        window.eventBus.subscribe([USER_JURISDICTION_UPDATED, GAME_SESSION_UPDATED], function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.jurisdiction = (_a = event.payload) === null || _a === void 0 ? void 0 : _a[0];
                        this.gameSession = (_b = event.payload) === null || _b === void 0 ? void 0 : _b[1];
                        return [4 /*yield*/, this.updateNetPositionBar()];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    GameSessionService.prototype.subscribeToEnableContinuePlayingChanges = function () {
        var _this = this;
        window.eventBus.subscribe([USER_JURISDICTION_UPDATED, BREAKPOINT_DEVICE_UPDATED], function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.jurisdiction = (_b = event.payload) === null || _b === void 0 ? void 0 : _b[0];
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(DEVICE_QUERY_IS_DESKTOP)];
                    case 1:
                        _a.isDesktop = _c.sent();
                        return [4 /*yield*/, this.updateEnableContinuePlaying()];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
        window.queryBus.subscribe(ENABLE_CONTINUE_PLAYING_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldEnableContinuePlaying()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
    };
    GameSessionService.prototype.updateNetPositionBar = function () {
        return __awaiter(this, void 0, void 0, function () {
            var visible;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldShowNetPositionBar()];
                    case 1:
                        visible = _a.sent();
                        if (visible) {
                            this.initNetPositionTracking();
                        }
                        else {
                            this.resetNetPositionTracking();
                        }
                        window.eventBus.publish(NET_POSITION_BAR_UPDATED, visible);
                        return [2 /*return*/];
                }
            });
        });
    };
    GameSessionService.prototype.initNetPositionTracking = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.netPosition = 0;
                        window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, 0);
                        if (!this.isCoreX) return [3 /*break*/, 2];
                        if (this.netPositionSubscription) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, magic.invokeCached(60, magic.methods.wallet, 'getGamingCoreXAccounts')()];
                    case 1:
                        _a.userWallets = (_b.sent());
                        this.netPositionSubscription = magic.events.accountChangedCoreX(function (balance) {
                            var _a, _b, _c, _d;
                            var currentSpinBalance = (_a = balance.aggregates['casino-balance']) === null || _a === void 0 ? void 0 : _a.amount;
                            if (currentSpinBalance !== undefined) {
                                if (_this.firstNetPosition) {
                                    var wallet = (_b = _this.userWallets) === null || _b === void 0 ? void 0 : _b.find(function (wallet) {
                                        return wallet.walletId === balance.walletId;
                                    });
                                    var initialBalance = (_d = (_c = wallet === null || wallet === void 0 ? void 0 : wallet.aggregates['casino-balance']) === null || _c === void 0 ? void 0 : _c.amount) !== null && _d !== void 0 ? _d : 0;
                                    _this.initializeNetPosition(initialBalance, currentSpinBalance);
                                }
                                else {
                                    _this.updateNetPosition(currentSpinBalance);
                                }
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.gameTransactionSubscription) {
                            return [2 /*return*/];
                        }
                        this.gameTransactionSubscription = magic.events.gameTransaction(function (event) {
                            if (!(event.amount > 0)) {
                                return;
                            }
                            _this.netPosition +=
                                event.balanceAfter - event.balanceBefore;
                            window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, _this.netPosition);
                        });
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GameSessionService.prototype.initializeNetPosition = function (initialBalance, currentSpinBalance) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.netPosition = initialBalance * -1 + currentSpinBalance;
                this.previousSpinBalance = currentSpinBalance;
                window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, this.netPosition);
                this.firstNetPosition = false;
                return [2 /*return*/];
            });
        });
    };
    GameSessionService.prototype.updateNetPosition = function (currentSpinBalance) {
        this.netPosition =
            this.netPosition +
                (this.previousSpinBalance * -1 + currentSpinBalance);
        this.previousSpinBalance = currentSpinBalance;
        window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, this.netPosition);
    };
    GameSessionService.prototype.resetNetPositionTracking = function () {
        var _a, _b;
        this.netPosition = 0;
        window.eventBus.publish(NET_POSITION_AMOUNT_UPDATED, 0);
        (_a = this.gameTransactionSubscription) === null || _a === void 0 ? void 0 : _a.unsub();
        this.gameTransactionSubscription = null;
        (_b = this.netPositionSubscription) === null || _b === void 0 ? void 0 : _b.unsub();
        this.netPositionSubscription = undefined;
    };
    GameSessionService.prototype.updateEnableContinuePlaying = function () {
        return __awaiter(this, void 0, void 0, function () {
            var enable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shouldEnableContinuePlaying()];
                    case 1:
                        enable = _a.sent();
                        window.eventBus.publish(ENABLE_CONTINUE_PLAYING_UPDATED, enable);
                        return [2 /*return*/];
                }
            });
        });
    };
    GameSessionService.prototype.shouldEnableContinuePlaying = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.isDesktop &&
                            !this.isNetPositionBarAvailableForJurisdiction();
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isEnableContinuePlayingAllowed()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, (_a)];
                }
            });
        });
    };
    GameSessionService.prototype.shouldShowNetPositionBar = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var loggedIn, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        loggedIn = !!magic.session.getUser();
                        _b = loggedIn &&
                            !!((_a = this.gameSession) === null || _a === void 0 ? void 0 : _a.active) &&
                            this.isNetPositionBarAvailableForJurisdiction();
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.disableNetPositionBarFlag()];
                    case 1:
                        _b = !(_c.sent());
                        _c.label = 2;
                    case 2: return [2 /*return*/, (_b)];
                }
            });
        });
    };
    GameSessionService.prototype.disableNetPositionBarFlag = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var disableGameplayInfoFlag, disabledForVendors, vendor;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(FEATURE_QUERY_VALUE, {
                            slug: Feature.GAMEPLAY_INFORMATION_DISABLED,
                        })];
                    case 1:
                        disableGameplayInfoFlag = _b.sent();
                        disabledForVendors = disableGameplayInfoFlag === null || disableGameplayInfoFlag === void 0 ? void 0 : disableGameplayInfoFlag.value.toLowerCase();
                        vendor = (_a = this.gameSession) === null || _a === void 0 ? void 0 : _a.vendor.toLowerCase();
                        return [2 /*return*/, ((disableGameplayInfoFlag === null || disableGameplayInfoFlag === void 0 ? void 0 : disableGameplayInfoFlag.isApplicable) &&
                                vendor &&
                                disabledForVendors.includes(vendor))];
                }
            });
        });
    };
    GameSessionService.prototype.isNetPositionBarAvailableForJurisdiction = function () {
        return isUKGC(this.jurisdiction) || isAGCO(this.jurisdiction);
    };
    GameSessionService.prototype.isEnableContinuePlayingAllowed = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('enableContinuePlaying')];
                    case 1: return [2 /*return*/, !!(_a.sent())];
                }
            });
        });
    };
    GameSessionService.prototype.registerSchemas = function () {
        window.eventBus.register(NET_POSITION_BAR_UPDATED, {
            type: 'boolean',
        });
        window.eventBus.register(ENABLE_CONTINUE_PLAYING_UPDATED, {
            type: 'boolean',
        });
        window.queryBus.register(ENABLE_CONTINUE_PLAYING_QUERY, {
            type: 'boolean',
        });
        window.eventBus.register(GAME_SESSION_UPDATED, {
            type: 'object',
            properties: {
                active: {
                    type: 'boolean',
                },
                sessionStartMs: {
                    type: 'number',
                },
                vendor: {
                    type: 'string',
                },
            },
        });
    };
    return GameSessionService;
}());

export { GameSessionService };
